import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { AuthGuard } from './components/auth/AuthGuard';
import { UpgradeModal } from './components/membership/UpgradeModal';
import HomePage from './pages/HomePage';
import MarketDetailPage from './pages/MarketDetailPage';
import LoginPage from './pages/LoginPage';
import BonusPoolPage from './pages/BonusPoolPage';
import BonusPoolRoundsPage from './pages/BonusPoolRoundsPage';
import BonusPoolInvitePage from './pages/BonusPoolInvitePage';
import PaymentPage from './pages/PaymentPage';
import NotFoundPage from './pages/NotFoundPage';
import AccountPage from './pages/AccountPage';

function AppContent() {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [currentTierOverride, setCurrentTierOverride] = useState(null);
  const { user } = useAuth();

  // 监听会员权限不足事件
  useEffect(() => {
    const handleMembershipRequired = (event) => {
      setCurrentTierOverride(event.detail?.currentTier || null);
      setShowUpgradeModal(true);
    };

    window.addEventListener('membership-required', handleMembershipRequired);
    return () => {
      window.removeEventListener('membership-required', handleMembershipRequired);
    };
  }, []);

  const effectiveTier = currentTierOverride || user?.tier_name || 'free';

  return (
    <>
      <Routes>
        <Route path="/bonus-pool" element={<BonusPoolPage />} />
        <Route path="/bonus-pool/rounds" element={<BonusPoolRoundsPage />} />
        <Route path="/bonus-pool/invite/:code" element={<BonusPoolInvitePage />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="market/:marketId" element={<MarketDetailPage />} />
        </Route>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/account"
          element={
            <AuthGuard>
              <AccountPage />
            </AuthGuard>
          }
        />
        <Route
          path="/payment/:orderId"
          element={
            <AuthGuard>
              <PaymentPage />
            </AuthGuard>
          }
        />
        {/* 404 页面 - 捕获所有未匹配的路由 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {/* 全局升级弹窗 */}
      <UpgradeModal
        isOpen={showUpgradeModal}
        onClose={() => {
          setShowUpgradeModal(false);
          setCurrentTierOverride(null);
        }}
        currentTier={effectiveTier}
      />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
